import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Events from "./Pages/Events";
import Sermons from "./Pages/Sermons";
import Donations from "./Pages/Donations";
import EOTCCalendar from "./Pages/EOTCCalendar";
import Contact from "./Pages/Contact";
import Login from "./Pages/Login";
import MemberPortal from "./Pages/MemberPortal";
import MemberLogin from "./Pages/MemberLogin";
import MemberDashboard from "./Pages/MemberDashboard";
import MemberVerifyEmail from "./Pages/MemberVerifyEmail";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import ConfirmEmailChange from "./Pages/ConfirmEmailChange";
import MemberPaymentSuccess from "./Pages/MemberPaymentSuccess";
import MemberPaymentCancelled from "./Pages/MemberPaymentCancelled";
import AdminLogin from "./Pages/AdminLogin";
import AdminDashboard from "./Pages/AdminDashboard";
import { pageRoutes } from "./utils";
import { LanguageProvider } from "./i18n";

const routeConfig = [
  { path: pageRoutes.Home, pageName: "Home", element: <Home /> },
  { path: pageRoutes.About, pageName: "About", element: <About /> },
  { path: pageRoutes.Events, pageName: "Events", element: <Events /> },
  { path: pageRoutes.Sermons, pageName: "Sermons", element: <Sermons /> },
  {
    path: pageRoutes.Donations,
    pageName: "Donations",
    element: <Donations />,
  },
  {
    path: pageRoutes.Calendar,
    pageName: "Calendar",
    element: <EOTCCalendar />,
  },
  { path: pageRoutes.Contact, pageName: "Contact", element: <Contact /> },
  { path: pageRoutes.Login, pageName: "Login", element: <Login /> },
  {
    path: pageRoutes.MemberPortal,
    pageName: "MemberPortal",
    element: <MemberPortal />,
  },
  {
    path: pageRoutes.MemberRegister,
    pageName: "MemberRegister",
    element: <MemberPortal />,
  },
  {
    path: pageRoutes.MemberVerifyEmail,
    pageName: "MemberVerifyEmail",
    element: <MemberVerifyEmail />,
  },
  {
    path: pageRoutes.ForgotPassword,
    pageName: "ForgotPassword",
    element: <ForgotPassword />,
  },
  {
    path: pageRoutes.ResetPassword,
    pageName: "ResetPassword",
    element: <ResetPassword />,
  },
  {
    path: pageRoutes.ConfirmEmailChange,
    pageName: "ConfirmEmailChange",
    element: <ConfirmEmailChange />,
  },
  {
    path: pageRoutes.MemberLogin,
    pageName: "MemberLogin",
    element: <MemberLogin />,
  },
  {
    path: pageRoutes.MemberDashboard,
    pageName: "MemberDashboard",
    element: <MemberDashboard />,
  },
  {
    path: pageRoutes.MemberDashboardProfile,
    pageName: "MemberDashboardProfile",
    element: <MemberDashboard />,
  },
  {
    path: pageRoutes.MemberDashboardPayments,
    pageName: "MemberDashboardPayments",
    element: <MemberDashboard />,
  },
  {
    path: pageRoutes.MemberDashboardMembership,
    pageName: "MemberDashboardMembership",
    element: <MemberDashboard />,
  },
  {
    path: pageRoutes.MemberDashboardSettings,
    pageName: "MemberDashboardSettings",
    element: <MemberDashboard />,
  },
  {
    path: pageRoutes.MemberPaymentSuccess,
    pageName: "MemberPaymentSuccess",
    element: <MemberPaymentSuccess />,
  },
  {
    path: pageRoutes.MemberPaymentCancelled,
    pageName: "MemberPaymentCancelled",
    element: <MemberPaymentCancelled />,
  },
  {
    path: pageRoutes.AdminLogin,
    pageName: "AdminLogin",
    element: <AdminLogin />,
  },
  {
    path: pageRoutes.AdminDashboard,
    pageName: "AdminDashboard",
    element: <AdminDashboard />,
  },
  {
    path: pageRoutes.AdminMembers,
    pageName: "AdminMembers",
    element: <AdminDashboard />,
  },
  {
    path: pageRoutes.AdminMemberDetail,
    pageName: "AdminMemberDetail",
    element: <AdminDashboard />,
  },
  {
    path: pageRoutes.AdminPayments,
    pageName: "AdminPayments",
    element: <AdminDashboard />,
  },
  {
    path: pageRoutes.AdminSettings,
    pageName: "AdminSettings",
    element: <AdminDashboard />,
  },
];

function App() {
  return (
    <LanguageProvider>
      <Routes>
        {routeConfig.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <Layout currentPageName={route.pageName}>{route.element}</Layout>
            }
          />
        ))}
        <Route path="*" element={<Navigate to={pageRoutes.Home} replace />} />
      </Routes>
    </LanguageProvider>
  );
}

export default App;
